function IconSimpleSmartPhone({ fill, stroke }) {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 12H0V8.5V3C0 1.34315 1.34315 0 3 0H10V8.5V9C10 10.6569 8.65685 12 7 12Z" fill={fill} />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 8H9V1H3C1.89543 1 1 1.89543 1 3V8ZM0 3C0 1.34315 1.34315 0 3 0H10V9C10 10.6569 8.65685 12 7 12H0V3ZM1 11V9H9C9 10.1046 8.10457 11 7 11H1ZM6.5 3.5H3.5V2.5H6.5V3.5Z" fill={stroke} />
    </svg>
  )
}

export default IconSimpleSmartPhone